import React, { useState, useEffect, useRef } from "react";
import { Badge, Button, Card, Col, Container, Row } from "react-bootstrap";
import Confirm from "../Confirm";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import WhiteObjectApi from "../../api/WhiteObjectApi";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import FilesCreate from "../File/FilesCreate";
import RelatedListFiles from "../File/RelatedListFiles";
import Path from "../common/Path";
import moment from "moment";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";
import * as constants from "../../constants/CONSTANT";
import RelatedListPriceBook from "../PriceBook/RelatedListPriceBook";
import PubSub from "pubsub-js";
import jwt_decode from "jwt-decode";
import Helmet from "react-helmet";
import Main from "../layout/Main";
import PriceBookCreate from "../PriceBook/PriceBookCreate";
import Image from 'react-bootstrap/Image';
import Permissionhelper from "../common/Permissionhelper";
import './Project.css'
const LeadView = (props) => {

    const containerRef = useRef(null);
    const [scrollWidth, setScrollWidth] = useState(0);
    const [animationDuration, setAnimationDuration] = useState(0);
    const [stopAnimation, setStopAnimation] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();
    const [lead, setLead] = useState(location.state ? location.state : {});
    // const [data, setData] = useState([]);
    // const [modalShow, setModalShow] = useState(false);
    // const [relatedListFiles, setRelatedListFiles] = useState(true);
    // const [refreshTaskList, setRefreshPriceBook] = useState();
    // const [modalShowFile, setModalShowFile] = useState(false);
    // const [modalPriceBook, setModalPriceBook] = useState(false);
    // const [modalShowEmail, setModalShowEmail] = useState(false);
    // const [relatedListPriceBook, setrelatedListPriceBook] = useState(false);
    // const [refreshFileList, setRefreshFileList] = useState();
    const [imageData, setImageData] = useState([]);

    const [userInfo, setUserInfo] = useState({});

    useEffect(() => {
        setUserInfo(jwt_decode(localStorage.getItem("token")));
        fetchLead();
    }, []);

    const fetchLead = () => {
        // Fetch lead details and image data
        if (!lead.id && location.hasOwnProperty("pathname") && location.pathname.split("/").length >= 3) {
            lead.id = location.pathname.split("/")[2];
        }

        async function initProduct() {
            try {
                // let result = await WhiteObjectApi.fetchProductById(lead.id);
                // console.log("Lead data:", result);


                let foldername = 'ProjectSiteCompletedImages';

                let productImageResult = await WhiteObjectApi.fetchFilesFolderWise(foldername);
                console.log("Product image result:", productImageResult);

                if (productImageResult && productImageResult.length > 0) {
                    let imagePromises = productImageResult.map(async (file) => {
                        let imageBlob = await WhiteObjectApi.downloadFiles(file.id, foldername);
                        return new Promise((resolve) => {
                            let reader = new FileReader();
                            reader.readAsDataURL(imageBlob);
                            reader.onloadend = () => {
                                resolve(reader.result); // base64 string
                            };
                        });
                    });

                    let base64Images = await Promise.all(imagePromises);
                    setImageData(base64Images); // base64Images is an array
                }


            } catch (error) {
                console.error("Error fetching images:", error);
            }

        }

        initProduct();
    };

    function chunkArray(array, size) {
        const chunked = [];
        for (let i = 0; i < array.length; i += size) {
            chunked.push(array.slice(i, i + size));
        }
        return chunked;
    }

    useEffect(() => {
        if (!containerRef.current || !imageData || imageData.length === 0) return;

        // Measure the component Width and translate accordingly as well se decide it's duration
        const measureWidth = () => {
            const fullWidth = containerRef.current?.scrollWidth || 0;
            setScrollWidth(fullWidth / 2);

            const speed = 0.1;
            setAnimationDuration((fullWidth / 2) / speed);
        };

        measureWidth();

        const resizeObserver = new ResizeObserver(() => {
            measureWidth();
        });

        resizeObserver.observe(containerRef.current);
        return () => {
            resizeObserver.disconnect();
        };
    }, [imageData]);

     return (
    <div className="project-scroll-wrapper">
      {chunkArray(imageData, 15).map((row, rowIndex) => (
        <div
          key={rowIndex}
          className="scroll-row"
          onMouseEnter={() => setStopAnimation(true)}
          onMouseLeave={() => setStopAnimation(false)}
        >
          <div
            className="scroll-content-project"
            ref={containerRef}
            style={{
              animation: `scrollLeftToRight ${animationDuration}ms linear infinite`,
              animationPlayState: stopAnimation ? "paused" : "running",
            }}
          >
            {[...row, ...row].map((img, i) => (
              <img key={i} src={img} alt="" className="marquee-image" />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default LeadView;